import { render } from "./header.vue?vue&type=template&id=421e92f7"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=421e92f7&lang=css"

import exportComponent from "/codebuild/output/src3474900079/src/relsify_nft_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__